



































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {InputGithubOrganizationSchema} from '@/schema/resource/GithubOrganization/InputGithubOrganizationSchema'
import {InputSelect, InputText} from '@simpli/vue-input'
import {SocialTypeCollection} from '@/model/collection/SocialTypeCollection'
import {SocialType} from '@/model/resource/SocialType'
import {GithubOrganizationSocialTypeCollection} from '@/model/collection/GithubOrganizationSocialTypeCollection'
import {GithubOrganizationSocialType} from '@/model/resource/GithubOrganizationSocialType'

@Component({
  components: {InputSelect, InputText},
})
export default class PersistGithubOrganizationView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputGithubOrganizationSchema()
  githubOrganization = new GithubOrganization()

  socialTypeCollection = new SocialTypeCollection()
  socialCollection = new GithubOrganizationSocialTypeCollection()
  socials: GithubOrganizationSocialType[] = []

  selectedSocialType: SocialType | null = null
  socialUrl: string = ''
  pendingSocials: GithubOrganizationSocialType[] = []

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.githubOrganization.getGithubOrganization(id)
    }

    await this.populateSocialTypes()
    await this.populateSocials()

    this.$await.done('getGithubOrganization')
  }

  get socialTypeOptions() {
    return (this.socialTypeCollection.items || []).filter(
      it => it.active !== false
    )
  }

  get canAddSocial() {
    return !!this.selectedSocialType && !!this.socialUrl
  }

  async populateSocialTypes() {
    this.socialTypeCollection.perPage = 200
    await this.socialTypeCollection.queryAsPage()
  }

  async populateSocials() {
    const idOrg = this.githubOrganization.$id || 0
    if (!idOrg) {
      this.socials = this.pendingSocials.slice()
      return
    }

    this.socialCollection.perPage = 200
    this.socialCollection.idOrganizationFk = idOrg
    await this.socialCollection.queryAsPage()
    this.socials = this.socialCollection.items.slice()
  }

  addSocial() {
    if (!this.selectedSocialType) return
    if (!this.socialUrl) return

    const social = new GithubOrganizationSocialType()
    social.githubOrganization = this.githubOrganization
    social.socialType = this.selectedSocialType
    social.url = this.socialUrl

    const exists = this.socials.some(
      s => s.socialType?.$id === this.selectedSocialType?.$id
    )
    if (!exists) {
      this.socials = [...this.socials, social]
      if (!this.githubOrganization.$id) {
        this.pendingSocials = [...this.pendingSocials, social]
      } else {
        // Persist immediately on edit
        social.persistGithubOrganizationSocialType()
      }
    }

    this.selectedSocialType = null
    this.socialUrl = ''
  }

  async removeSocial(item: GithubOrganizationSocialType) {
    this.socials = this.socials.filter(s => s !== item)
    this.pendingSocials = this.pendingSocials.filter(s => s !== item)

    if (this.githubOrganization.$id) {
      await item.removeGithubOrganizationSocialType()
    }
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.githubOrganization.persistGithubOrganization()

    // Persist socials created during "new" flow
    if (this.pendingSocials.length) {
      const socials = this.pendingSocials.slice()
      this.pendingSocials = []
      await Promise.all(
        socials.map(s => s.persistGithubOrganizationSocialType())
      )
    }

    this.$toast.success('system.success.persist')
    await this.$nav.push('/github-organization/list')
  }
}
